import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Page, Card, DataTable, AppProvider, Link, Button, ButtonGroup, ResourceList, Badge, Select, Checkbox, Pagination, Spinner } from '@shopify/polaris';
import FilterTableProvider from '@container/FilterTableProvider';

import { sectionColumns } from 'utils/recordHelpers'

const propTypes = {
  records: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  newURL: PropTypes.string,
  title: PropTypes.string.isRequired,
  resourceType: PropTypes.string.isRequired,
};

const SectionIndex = (props) => {
  const { totalPages, records } = props;
  const primaryAction = props.newURL ? { content: 'Agregar Sección', url: props.newURL } : null;
  
  return (
    <FilterTableProvider
      pageProps={{
        title: props.title,
        primaryAction: primaryAction,
      }}
      resourceTableProps={{
        itemURL: "/sections",
        urlAction: `edit?resource=${props.resourceType}`
      }}
  
      initialTotalPages={ totalPages }
      initialRecords={ records }
      columnsInfo={ sectionColumns }
    >
    </FilterTableProvider>
  );
}

SectionIndex.propTypes = propTypes;


export default SectionIndex;
